import {Promise} from "@securionpay-internal/commons-js";

export const timeoutPromise = function (ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export const rejectOnTimeout = function <T>(promise: Promise<T>, ms: number, message: string = "Timeout"): Promise<T> {
    return new Promise((resolve, reject) => {
        let finished = false
        const onResultCallback = (callback) => (...params) => {
            if (finished) {
                return;
            }
            finished = true;
            callback(...params)
        }
        timeoutPromise(ms).then(onResultCallback(() => reject(new Error(message))));
        promise.then(onResultCallback(resolve), onResultCallback(reject))
    });
};